/**
 * App-scoped localStorage key builder.
 *
 * localStorage is scoped to scheme+host+port, NOT to the app — so every dev app that
 * has ever run on this machine's Vite port shares one bucket. That is not theoretical:
 * this origin was found holding keys from several unrelated local projects
 * (`gitAppChatMode`, `datamig:*`, `dbmig:*`, `admin.orders.filters.v1`, `persist:root`,
 * `theme`, …). The ai-builder scaffold ships generic `app:*` keys, which every scaffolded
 * app would also claim — so a stale `app:auth` written by a DIFFERENT app on the same
 * port could be read back here as a logged-in user the server never authenticated.
 *
 * Prefixing with the app name makes collisions impossible regardless of which port this
 * app is served from. Route every new localStorage key through this helper.
 */
const NAMESPACE = 'devtools';

export function storageKey(name) {
  return `${NAMESPACE}:${name}`;
}
